import React, { Component } from 'react';
import { connect } from 'react-redux';

import clone from 'fast-clone';
import {
    getLeagueLeaderBoardData,
} from './../../actions/LeagueActions';
import {
    getFixtures,
} from './../../actions/ManageTeamActions';
import LeagueShare from './league-share';
import { addFixturesStatus } from './../../helper'
import { concat, filter, uniqBy, find } from 'lodash';
import OutsideNotifier from '../../OutsideNotifier';
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import GeneralPopUp from './../GeneralPopUp';
import { shareLeagueOnFacebook, shareLeagueOnTwitter } from './../../share';
import AdBottom from '../AdBottom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import trackEventsObj from '../../constants/new-pageTrackEvents'

class LeagueLeaderBoard extends Component {
    setInitialState = () => {
        this.setState({
            responseData: {},
            userSpecificFixtures: [],
            isDDOpen: false,
            currentActiveFixture: 0,
            popupProps: {
                message: '',
                inlineMessage: '',
                popupWrapperClass: '',
                iconClass: '',
                showPopup: false,
            },
            showToolTip: false,
            showAchievementsToolTip: false,
            showShare: false,
            copied: false,
            linkCopied: false
        });
        this.pageNumber = 1;
        this.vPageChunk = 50,//common.isMobile() ? 20 : 25;
            this.self = [];
        this.defaultFilter = {
            isOverAll: true,
        };
        this.reqInput = [0, 0, 1];
    };

    componentWillMount() {
        this.setInitialState();
    }

    componentDidMount() {
        if (Boolean(sessionStorage.getItem('leagueCreated')) === true) {
            sessionStorage.removeItem('leagueCreated');
            this.handleToast({
                message: this.props.trans['LEAGUE_SUCCESS'],
                leagueCreated: true,
                isToast: true,
                popupWrapperClass: 'si-warning-toast si-success-popup',
                iconClass: 'icon-ucl-tick',
                showPopup: true
            });
        }
        if (Boolean(sessionStorage.getItem('joinTeamSuccess')) === true) {
            sessionStorage.removeItem('joinTeamSuccess');
            this.handleToast({
                message: this.props.trans['LEAGUE_JOIN_SUCCESS'],
                leagueCreated: true,
                isToast: true,
                popupWrapperClass: 'si-warning-toast si-success-popup',
                iconClass: 'icon-ucl-tick',
                showPopup: true
            });
        }
        this.getLeaderBoard();
        this.props.getFixtures().then(() => {
            const { fixtures } = this.props;
            const fixturesWithStatus = addFixturesStatus(fixtures);
            let allowedStatus = [config.fixtureStatus.isFinished, config.fixtureStatus.isSubstitution];
            const filteredFixtures = filter(fixturesWithStatus, (fixture) => {
                // return allowedStatus.indexOf(fixture.status) > -1;
                return fixture.ShowLeaderboards == 1
            });
            let uniquePhaseIDs = uniqBy(filteredFixtures, (a, b) => {
                return a['PhID'];
            });
            let uniqueMDIDs = uniqBy(filteredFixtures, (a, b) => {
                return a.GDID;
            });
            uniquePhaseIDs = clone(uniquePhaseIDs).map(el => {
                el.isPhase = true;
                return el;
            });
            uniqueMDIDs = clone(uniqueMDIDs).map(el => {
                el.isMDID = true;
                return el;
            });
            const userSpecificFixtures = concat(this.defaultFilter, uniquePhaseIDs, uniqueMDIDs);
            this.setState({ userSpecificFixtures });
        });
    }

    getLeaderBoard = (isShowMoreClicked) => {
        let self = this;
        const { leagueID } = this.props.match.params;
        if (!leagueID) return;
        const phaseID = this.reqInput[0] || 0;
        const gamedayId = this.reqInput[1] || 0;
        const opType = this.reqInput[2] || 1;
        common.showLoader();
        this.props.getLeagueLeaderBoardData(opType, this.pageNumber, this.vPageChunk, this.vPageChunk,
            leagueID, phaseID, gamedayId, this.vPageChunk).then(() => {
                common.hideLoader();
                if (isShowMoreClicked) {
                    common.customTracking('Leaderboard - Load More');
                }
                const response = self.props.leagueLeaderBoard;
                const errorKeyFromTrans = apiError.leagues;
                const message = self.props.trans[errorKeyFromTrans];
                if (!response) {
                    let stateToSet = {
                        message,
                        popupWrapperClass: 'si-error-popup',
                        iconClass: 'icon-ucl-close',
                        showPopup: true
                    };
                    self.handleToast(stateToSet);
                } else {
                    const { Rest } = response;
                    let dataToSet = {};
                    const { responseData } = self.state;
                    if (response.TotalMembers == 1) {
                        common.pageViewTracking("", trackEventsObj["emptyLeagueDetails"]);
                        common.pageViewTracking("", trackEventsObj["LeagueInviteLayer"]);
                    } else {
                        if (response.TotalMembers > 1) {
                            common.pageViewTracking("", trackEventsObj["LeagueDetails"]);
                        }
                    }
                    const previousRestData = responseData && responseData.Rest ? responseData.Rest : [];
                    if (self.pageNumber === 1) {
                        dataToSet = { responseData: response };
                    } else {
                        const mergedRest = concat(previousRestData, Rest);
                        const oldResponseData = { ...responseData };
                        dataToSet = { responseData: oldResponseData };
                        dataToSet.responseData.Rest = mergedRest;
                    }
                    if (dataToSet.responseData && dataToSet.responseData['TotalMembers'] === dataToSet.responseData.Rest.length) {
                        dataToSet.areAllLoaded = true;
                    }

                    self.setState(dataToSet);
                    ++self.pageNumber;
                }
            });
    };
    handleToast = (popupState) => {
        this.setState({ popupProps: popupState });
    };
    resetToast = () => {
        this.handleToast({ popupProps: { showPopup: false, message: '' } });
    };
    onDDTap = () => {
        this.setState(prevState => ({
            isDDOpen: !prevState.isDDOpen,
        }));
    };
    onPreviousTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: --currentActiveFixture, areAllLoaded: false });
        this.getRespectiveData(currentActiveFixture);
    };
    onNextTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: ++currentActiveFixture, areAllLoaded: false });
        this.getRespectiveData(currentActiveFixture);
    };
    onSelect = (currentActiveFixture) => {
        this.setState({ currentActiveFixture, isDDOpen: !this.state.isDDOpen, areAllLoaded: false });
        this.getRespectiveData(currentActiveFixture);
    };
    getRespectiveData = (currentActiveFixture) => {
        const { userSpecificFixtures } = this.state;
        const el = userSpecificFixtures[currentActiveFixture];
        this.pageNumber = 1;
        this.setState({ responseData: {} });
        this.reqInput = el.isOverAll ? [0, 0, 1] :
            el.isMDID ? [0, el['GDID'], 2] :
                el.isPhase ? [el['PhID'], 0, 3] : [0, 0, 1];
        this.getLeaderBoard();
    };
    onBackClick = () => {
        return this.props.history.goBack();
    };
    JoinTap = (isFromIcon, showCard) => {
        if (isFromIcon) {
            if (showCard) {
                common.customTracking('Invite Users - Icon', '/uclfantasy/leagues/private/empty/');
            }
            else {
                common.customTracking('Invite Users - Icon', '/uclfantasy/leagues/private/');
            }

        }

        this.setState((previousState) => {
            return { showShare: !previousState.showShare };
        });
    };
    onTooltipOutsideClick = () => {
        this.setState((previousState) => {
            return { showToolTip: !previousState.showToolTip };
        });
    };
    onAchievementsTooltipOutsideClick = () => {
        this.setState((previousState) => {
            return { showAchievementsToolTip: !previousState.showAchievementsToolTip };
        });
    };
    goToSettings = (leagueID) => {
        common.customTracking('League Settings');
        return this.props.history.push('/league-settings/' + leagueID);
    };

    getText(TotalMembers) {
        const membersCount = config.MEMBERS_COUNT_REQUIRED_FOR_ACHIEVEMENTS - TotalMembers;
        const updatedHTML = this.props.trans['MEMBERS_COUNT_FOR_ACHIEVEMENTS'].replace('{HREF}', '#').replace('{MEMBERS}', membersCount);
        return { __html: updatedHTML };
    }

    goToTeam = (GUID, UserId, UserTeamId) => {
        if (GUID == "self") {
            // return this.props.history.push("/manage-team");
            return "/" + config.CURRENT_LANGUAGE + "/uclfantasy/manage-team";
        } else {
            // return this.props.history.push(`/team/${GUID}/${UserId}/${UserTeamId}/${this.reqInput[1]}/${this.reqInput[0]}`);
            return `/${config.CURRENT_LANGUAGE}/uclfantasy/team/${GUID}/${UserId}/${UserTeamId}/${this.reqInput[1]}/${this.reqInput[0]}`
        }

    };

    onCopy() {
        this.setState({ copied: true }, () => {
            common.customTracking('Share - Copy Code', '/uclfantasy/leagues/private/empty/');
            setTimeout(() => {
                this.setState({ copied: false })
            }, 2000)
        })
    }

    onCopyLink() {
        this.setState({ linkCopied: true }, () => {
            common.customTracking('Share - Copy Link', '/uclfantasy/leagues/private/empty/');
            setTimeout(() => {
                this.setState({ linkCopied: false })
            }, 2000)
        })
    }

    render() {
        const { trans, constraints } = this.props;
        const { responseData, userSpecificFixtures, currentActiveFixture, areAllLoaded, showToolTip, popupProps, showShare } = this.state;
        const { showPopup, message, popupWrapperClass, iconClass, isToast } = popupProps;
        if (Object.keys(responseData).length === 0) return null;
        let { LeagueName, LP_GamedayId, PointsGamedayId, Rest, Self, LeagueCode, TotalMembers, LeagueId, IsDefaultLeague, ShareLoad } = responseData;
        const popupPropsData = {
            showPopup,
            resetToast: this.resetToast,
            message,
            isToast,
            wrapperClass: popupWrapperClass,
            iconClass: iconClass
        };
        if (+IsDefaultLeague === 1) {
            //LeagueName = trans['defaultLeagueName'].replace('{TEAM_NAME}', LeagueName);
        }
        if (userSpecificFixtures.length === 0) return null;
        const matchDayTrans = trans['matchday'];
        const phaseTrans = trans['phase'];
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        // const selectedLabel = selectedMatchDay.isOverAll ? trans['overall'] :
        //     selectedMatchDay.isMDID ? matchDayTrans + ' ' + selectedMatchDay['GDID'] :
        //         selectedMatchDay.isPhase ? phaseTrans + ' ' + selectedMatchDay['PhID'] : null;
        let selectedLabel = null
        if (selectedMatchDay.isOverAll) {
            selectedLabel = trans['overall'] ? trans['overall'] : 'Overall';
        }
        if (selectedMatchDay.isMDID) {
            selectedLabel = trans['rd' + selectedMatchDay['GDID']]
                ? trans['rd' + selectedMatchDay['GDID']]
                : matchDayTrans + ' ' + selectedMatchDay['GDID'];
        }
        if (selectedMatchDay.isPhase) {
            selectedLabel = trans['ph' + selectedMatchDay['PhID']]
                ? trans['ph' + selectedMatchDay['PhID']]
                : phaseTrans + ' ' + selectedMatchDay['PhID'];
        }
        // const selectedLabel = selectedMatchDay.isOverAll
        //   ? trans['overall']
        //   : selectedMatchDay.isMDID
        //   ? trans['rd' + selectedMatchDay['GDID']]
        //   : selectedMatchDay.isPhase
        //   ? trans['ph' + selectedMatchDay['PhID']]
        //   : null;
        const isFirst = currentActiveFixture === 0;
        const isLast = currentActiveFixture === (userSpecificFixtures.length - 1);
        const prevBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_right': true,
            'si-disabled': isFirst
        });
        const nextBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_left': true,
            'si-disabled': isLast
        });
        const members = Rest || [];
        const isUserInRest = find(Rest, (el) => {
            return el.GUID === common.getGUID();
        });
        const tooltipClass = common.makeClasses({
            'si-copy-tt': true,
            'si-active': this.state.copied
        });
        const tooltipLinkClass = common.makeClasses({
            'si-copy-tt': true,
            'si-active': this.state.linkCopied
        });
        const dataToShare = { LeagueCode, LeagueId, LeagueName, ShareLoad, constraints };
        const showCard = TotalMembers === 1 && !common.isEndOfSeason(constraints.GamercardSubScenario);
        // const columnHeading = (selectedMatchDay.isPhase || selectedMatchDay.isMDID) ? (selectedLabel) : +LP_GamedayId === 0 ? trans['md'] : trans['matchday'] + ' ' + LP_GamedayId;

        let columnHeading = null;
        if (selectedMatchDay.isOverAll) {
            columnHeading = trans['MD' + LP_GamedayId]
                ? trans['MD' + LP_GamedayId]
                : matchDayTrans + ' ' + LP_GamedayId;
        }
        if (selectedMatchDay.isMDID) {
            columnHeading = trans['MD' + selectedMatchDay['GDID']]
                ? trans['MD' + selectedMatchDay['GDID']]
                : matchDayTrans + ' ' + selectedMatchDay['GDID'];
        }
        if (selectedMatchDay.isPhase) {
            columnHeading = trans['phaseShort' + selectedMatchDay['PhID']]
                ? trans['phaseShort' + selectedMatchDay['PhID']]
                : phaseTrans + ' ' + selectedMatchDay['PhID'];
        }

        let isEot = common.isEndOfSeason(constraints.GamercardSubScenario);
        let linkShareMsg = (trans['shareLeagueLinkMsg'] || "Join my official UCL {game_name} league! Use the code: {league_code} or the link below. Let's see who's really the best! {league_link}").replace("{game_name}", config.gameName).replace("{league_code}", LeagueCode).replace("{league_link}", ShareLoad)
        return <div className="si-main-component si-manage-team si-no-anim si-leagues">
            { showShare ? <LeagueShare { ...dataToShare } trans={ trans } toHide={ this.JoinTap.bind(this) } /> : null }
            <div className="si-container si-leaderboard-pg">
                <div className="si-top-section">
                    <div className="si-leagues-header si-flexBox">
                        <div className="si-back-btn si-cols">
                            <i className="icon-ucl-back_arrow si-display-block" onClick={ () => this.onBackClick() } />
                        </div>
                        <div className="si-cols si-header-txt">
                            <span>{ LeagueName }</span>
                            <span className="si-member-count">
                                {
                                    (
                                        TotalMembers > 1
                                            ?
                                            common.memberNotation(TotalMembers) + " "
                                            :
                                            "No "
                                    ) + (trans['members'] || "members")
                                }
                            </span>
                        </div>
                        <div className="si-common-menu">
                            { !showCard ? <div className="si-profile-icon">
                                <i className="icon-ucl-add-member" style={ isEot ? common.hideVisibility() : {} } onClick={ () => this.JoinTap(true, showCard) } />
                                {/*<div className={tooltipAchievementsClass}>
                                    <i className="icon-ucl-leagues-profile"
                                       onClick={() => this.onAchievementsTooltipOutsideClick()}/>
                                    {showAchievementsTooltip ? (showAchievementsToolTip ? <OutsideNotifier
                                        handler={() => this.onAchievementsTooltipOutsideClick()}>
                                        <div className="si-tooltip">
                                        <span dangerouslySetInnerHTML={this.getText(TotalMembers)}>
                                        </span>
                                        </div>
                                    </OutsideNotifier> : null) : null}
                                </div>*/}
                            </div> : null }
                            <div className="si-settings-icon" style={ isEot ? common.hideVisibility() : {} }>
                                <i className="icon-ucl-settings" onClick={ () => this.goToSettings(LeagueId) } />
                            </div>
                        </div>
                    </div>
                </div>
                { (showCard) ?
                    <div className="si-leagues-container si-sm-container si-column-layout">
                        <div className="si-leagues-card si-ls">
                            <div className="si-league-head">
                                <span className="si-league-title">{ trans['inviteYourFrnds'] || "Invite your friends" }</span>
                            </div>

                            <div className="si-league-body">
                                <div className="si-social-share">
                                    <span className="si-ls__title">{ trans['leagueLink'] || "League link" }</span>
                                    <span className="si-ls__desc">{ trans['inviteFriendsToLeague'] || "Invite friends to your league whenever you want by sharing this link." }</span>
                                    <div className="si-ls__code">{ (ShareLoad) }</div>
                                    <div className="si-share-med" style={ isEot ? common.hideVisibility() : {} }>
                                        <div className={ tooltipLinkClass }>
                                            <CopyToClipboard text={ linkShareMsg } onCopy={ () => this.onCopyLink() }>
                                                <div className="si-btn si-btn-primary">{ trans['shareLink'] || "Share link" }</div>
                                            </CopyToClipboard>
                                            <div className="si-tooltip">
                                                <div className="si-tt-desc">{ trans['league_copy2clip'] || "Copied to clipboard!" }</div>
                                            </div>
                                        </div>

                                        <div className="si-share-item si-fb-share" onClick={ (e) => {
                                            common.customTracking('Share - Facebook', '/uclfantasy/leagues/private/empty/');
                                            shareLeagueOnFacebook(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans)
                                        } }>
                                            <i className="icon-ucl-facebook"></i>
                                        </div>
                                        <div className="si-share-item si-tweet-share" onClick={ (e) => {
                                            common.customTracking('Share - Twitter  ', '/uclfantasy/leagues/private/empty/');
                                            shareLeagueOnTwitter(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans)
                                        } }>
                                            <i className="icon-ucl-twitter"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="si-join-code">
                                    <span className="si-ls__title">{ trans['leagueCode'] || "League code" }</span>
                                    <span className="si-ls__desc">{ trans['yourFrndsCanAlsoJoin'] || "Your friends can also join by entering this code." }</span>
                                    <div className="si-code-wrp">
                                        <span>{ LeagueCode }</span>
                                        <div className={ tooltipClass }>
                                            <CopyToClipboard text={ LeagueCode } onCopy={ () => this.onCopy() }>
                                                <div className="si-btn si-btn-secondary">{ trans['copy'] || "Copy" }</div>
                                            </CopyToClipboard>
                                            <div className="si-tooltip">
                                                <div className="si-tt-desc">{ trans['league_copy2clip'] || "Copied to clipboard!" }</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    : <div className="si-leagues-container si-column-layout">
                        <div className="si-selectbox">
                            <div className="si-dropdown-btn">
                                <i className={ prevBtnClasses } onClick={ () => this.onPreviousTap() } />
                                <span onClick={ () => this.onDDTap() }>{ selectedLabel }</span>
                                <i className={ nextBtnClasses } onClick={ () => this.onNextTap() } />
                            </div>
                            { this.state.isDDOpen ? <OutsideNotifier handler={ () => this.onDDTap() }>
                                <ul className="si-dropdown-options">
                                    { userSpecificFixtures.map((el, index) => {
                                        // const selectedLabel = el.isOverAll ? trans['overall'] :
                                        //     el.isMDID ? matchDayTrans + ' ' + el['GDID'] :
                                        //         el.isPhase ? phaseTrans + ' ' + el['PhID'] : null;

                                        let selectedLabel = null
                                        if (el.isOverAll) {
                                            selectedLabel = trans['overall'] ? trans['overall'] : 'Overall';
                                        }
                                        if (el.isMDID) {
                                            selectedLabel = trans['rd' + el['GDID']]
                                                ? trans['rd' + el['GDID']]
                                                : trans['rd' + el['GDID']];
                                        }
                                        if (el.isPhase) {
                                            selectedLabel = trans['ph' + el['PhID']]
                                                ? trans['ph' + el['PhID']]
                                                : phaseTrans + ' ' + el['PhID'];
                                        }

                                        // const selectedLabel = el.isOverAll
                                        //   ? trans['overall']
                                        //   : el.isMDID
                                        //   ? trans['rd' + el['GDID']]
                                        //   : el.isPhase
                                        //   ? trans['ph' + el['PhID']]
                                        //   : null;
                                        const isSelected = currentActiveFixture === index ? 'si-selected' : '';
                                        return <li key={ index } className={ isSelected }
                                            onClick={ () => this.onSelect(index) }>
                                            <span>{ selectedLabel }</span></li>
                                    }) }
                                </ul>
                            </OutsideNotifier> : null }
                        </div>
                        <div className="si-leaderboard ">
                            <div className="si-board-head">
                                <div className="si-row si-data-row">
                                    <div className="si-block si-name-wrp">
                                        <div className="si-rank">{ trans['rank'] }</div>
                                        <div className="si-plyr-info-wrap"></div>
                                    </div>
                                    <div className="si-block si-right-data">
                                        <div className="si-cell"><span className="">{ columnHeading }</span></div>
                                        {
                                            selectedMatchDay.isOverAll
                                                ?
                                                <div className="si-cell"><span className="">{ trans['total'] }</span></div>
                                                :
                                                null
                                        }
                                    </div>

                                </div>
                            </div>
                            <div className="si-board-body si-body">
                                { members.map((eachMember) => {
                                    const { UserId, UserTeamId, Trend, GUID, FullName, TeamName, BadgeId, OverallPoints, Rank, PhasePoints, GamedayPoints, CurrentGamedayPoints } = eachMember;
                                    let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                                    const trendClass = config.trend[Trend];
                                    const isUserSelf = GUID === common.getGUID();
                                    const wrapperClass = common.makeClasses({
                                        'si-data-row': true,
                                        'si-row': true,
                                        'si-current-user': isUserSelf
                                    });
                                    let handler = () => {
                                    };
                                    let path = ""
                                    if (!Rank) {
                                        path = "javascript:void(0)"
                                    } else {
                                        if (isUserSelf) {
                                            // handler = () => this.goToTeam("self");
                                            path = this.goToTeam("self");
                                        } else {
                                            // handler = () => this.goToTeam(GUID, UserId, UserTeamId);
                                            path = this.goToTeam(GUID, UserId, UserTeamId);
                                        }
                                    }

                                    const name = FullName + (isUserSelf ? ' ' + trans['you'] : '');
                                    const pts = selectedMatchDay.isOverAll ? CurrentGamedayPoints :
                                        selectedMatchDay.isPhase ? PhasePoints : GamedayPoints;
                                    return <a href={ path } className={ wrapperClass } key={ UserId }>
                                        <div className="si-block si-name-wrp">
                                            <div className="si-rank">
                                                <span className={ trendClass }>{ (Rank || '-') }</span>
                                            </div>
                                            <div className="si-plyr-info-wrap">
                                                <div className="si-plyr-info">
                                                    {/* <div className="si-badge-wrap">
                                                        <img src={imgSrc} alt={UserId} />
                                                        <div className="si-member-num">
                                                            <span>12</span>
                                                        </div>
                                                    </div> */}
                                                    <div className="si-names">
                                                        <span className="si-name-one">{ TeamName }</span>
                                                        <span className="si-user-name">{ name }</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="si-block si-right-data">
                                            <div className=" si-total si-cell">{ (pts || '-') }</div>
                                            {
                                                (selectedMatchDay.isOverAll)
                                                    ?
                                                    <div className=" si-total si-cell">{ (OverallPoints || '-') }</div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </a>
                                }) }
                                { areAllLoaded ? null : <a className="si-data-row si-row si-tbl-loader">
                                    <div className="si-block si-name-wrp">
                                        <div className="si-loader-dots">
                                            {/* <span className="si-dots si-dot1" />
                                            <span className="si-dots si-dot2" />
                                            <span className="si-dots si-dot3" /> */}
                                            <div className="si-btn si-btn-primary" onClick={ () => this.getLeaderBoard(true) }>
                                                <span>{ trans['loadFiftyMore'] || "Load 50 more rows" }</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="si-total si-cell" />
                                    <div className="si-total si-cell" />
                                </a> }
                                { !isUserInRest ? Self.map((eachMember) => {
                                    const { UserId, UserTeamId, Trend, GUID, FullName, TeamName, BadgeId, OverallPoints, Rank, PhasePoints, GamedayPoints, CurrentGamedayPoints } = eachMember;
                                    const memberFoundInRest = find(Rest, (el) => {
                                        return el.GUID === common.getGUID();
                                    });
                                    const isUserSelf = GUID === common.getGUID();
                                    if (memberFoundInRest) {
                                        return null;
                                    }
                                    let handler = () => {
                                    };
                                    let path = ""
                                    if (isUserSelf || Rank === null) {
                                        // handler = () => this.goToTeam("self");
                                        path = this.goToTeam("self");
                                    } else {
                                        // handler = () => this.goToTeam(GUID, UserId, UserTeamId);
                                        path = this.goToTeam(GUID, UserId, UserTeamId);
                                    }
                                    let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                                    const trendClass = config.trend[Trend];
                                    const wrapperClass = common.makeClasses({
                                        'si-data-row': true,
                                        'si-row': true,
                                        'si-current-user': isUserSelf
                                    });
                                    const pts = selectedMatchDay.isOverAll ? CurrentGamedayPoints :
                                        selectedMatchDay.isPhase ? PhasePoints : GamedayPoints;
                                    return <a href={ path } className={ wrapperClass } key={ UserId }>
                                        <div className="si-block si-name-wrp">
                                            <div className="si-rank">
                                                <span className={ trendClass }>{ Rank }</span>
                                            </div>
                                            <div className="si-plyr-info-wrap">
                                                <div className="si-plyr-info">
                                                    {/* <div className="si-badge-wrap">
                                                        <img src={imgSrc} alt={UserId} />
                                                        <div className="si-member-num">
                                                            <span>12</span>
                                                        </div>
                                                    </div> */}
                                                    <div className="si-names">
                                                        <span className="si-name-one">{ TeamName }</span>
                                                        <span className="si-user-name">{ FullName }</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="si-block si-right-data">
                                            <div className=" si-total si-cell">{ (pts || '-') }</div>
                                            {
                                                (selectedMatchDay.isOverAll)
                                                    ?
                                                    <div className=" si-total si-cell">{ (OverallPoints || '-') }</div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </a>
                                }) : null }
                            </div>
                        </div>
                    </div> }
                <AdBottom />
            </div>
            <GeneralPopUp { ...popupPropsData } />
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getFixtures: (GamedayId) => dispatch(getFixtures(GamedayId)),
        getLeagueLeaderBoardData: (opType, vPageNo, vPageChunk, vTopNo, leagueid, vPhaseId, gamedayId, vPageOneChunk) => dispatch(getLeagueLeaderBoardData(opType, vPageNo, vPageChunk, vTopNo, leagueid, vPhaseId, gamedayId, vPageOneChunk)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        fixtures: state.formationData.fixtures,
        leagueLeaderBoard: state.leaguesData.leagueLeaderBoard,
        constraints: state.appData.constraints,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(LeagueLeaderBoard));


// WEBPACK FOOTER //
// ./src/components/leagues/leagueLeaderBoard.js